import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

const AppHomePage = (): JSX.Element => <Navigate to="/timer" />;

export const Route = createFileRoute("/_app/")({
	component: AppHomePage,
});
